import React from 'react';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import FormattedText from './FormattedText/FormattedText.jsx';
import { useProject } from '../../hooks/useProject.jsx';
import SliderImages from './Slider/SliderImages.jsx';

const MobileProjectDetails = () => {
    const { projectDescription, projectSliderImages, isSliderLoading } = useProject();
    const isMobile = useMediaQuery('(max-width:800px)');

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
            }}
        >
            {/* Colonne 1 */}
            <Box
                item
                xs={3} // 1/4 de la largeur
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isMobile ? 2 : 10,
                    paddingRight: isMobile ? 2 : 0,
                    paddingTop: "10vh"
                }}
            >
                <FormattedText text={projectDescription} />
            </Box>

            {/* Colonne 2 */}
            <Box
                item
                xs={8} // 3/4 de la largeur
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%', // Assurez-vous que la hauteur est définie
                    padding: 2,

                }}
            >
                {
                    isSliderLoading ?
                        <div style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <CircularProgress />
                        </div> :
                        <SliderImages images={projectSliderImages} />

                }
            </Box>
        </Box>
    );
};

export default MobileProjectDetails;
